import type { TFunction } from "i18next"
import { z } from "zod"

export const AddNewUserAccessManagementFormSchema = (
  t: TFunction
) =>
  z
    .object({
      fullName: z
        .string()
        .min(1, t("validation.nameRequired")),
      email: z.string().email(t("validation.invalidEmail")),
      dashboardAccess: z.string(),
      scheduleAccess: z.string(),
      salesAccess: z.string(),
      ordersAccess: z.string(),
      subscribeAccess: z.string(),
      completeAccess: z.boolean().optional(),
    })
    .refine(
      (data) =>
        data.completeAccess ||
        data.dashboardAccess !==
          "dashboard-without-access" ||
        data.scheduleAccess !== "schedule-without-access" ||
        data.salesAccess !== "sales-without-access" ||
        data.ordersAccess !== "order-without-access" ||
        data.subscribeAccess !==
          "subscriptions-without-access",
      {
        message: t("validation.selectAtLeastOnePermission"),
        path: ["dashboardAccess"], // ou outro campo para exibir o erro
      }
    )
export type AddNewUserAccessManagementFormSchemaProps =
  z.infer<
    ReturnType<typeof AddNewUserAccessManagementFormSchema>
  >
